import { Link } from 'react-router-dom'
import clsx from 'clsx'

const variantStyles = {
  primary:
    'rounded-full bg-sky-300 py-2 px-4 text-sm font-semibold text-slate-900 hover:bg-sky-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300/50 active:bg-sky-500',
  secondary:
    'rounded-full bg-slate-800 py-2 px-4 text-sm font-medium text-white hover:bg-slate-700 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/50 active:text-slate-400',
}

type ButtonBaseProps = {
  variant?: keyof typeof variantStyles
  className?: string
}

type ButtonAsButton = ButtonBaseProps &
  Omit<React.ComponentPropsWithoutRef<'button'>, 'className'> & {
    href?: never
  }

type ButtonAsLink = ButtonBaseProps &
  Omit<React.ComponentPropsWithoutRef<typeof Link>, 'to' | 'className'> & {
    href: string
  }

type ButtonProps = ButtonAsButton | ButtonAsLink

export function Button({
  variant = 'primary',
  className,
  href,
  ...props
}: ButtonProps) {
  className = clsx(variantStyles[variant], className)

  return typeof href === 'undefined' ? (
    <button className={className} {...(props as ButtonAsButton)} />
  ) : (
    <Link className={className} to={href} {...(props as ButtonAsLink)} />
  )
}
